// Initialize tooltips

jQuery( function ( $ ) {
    $( '[data-toggle="tooltip"]' ).tooltip();
} );